module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/lb-ret-514.d989769c68fd19df.jpeg"+" 514w",
        images: [{path: "https://static.sniffspot.com/packs/img/lb-ret-514.d989769c68fd19df.jpeg",width: 514,height: 597}],
        src: "https://static.sniffspot.com/packs/img/lb-ret-514.d989769c68fd19df.jpeg",
        toString: function(){return "https://static.sniffspot.com/packs/img/lb-ret-514.d989769c68fd19df.jpeg"},
        
        width: 514,
        height: 597
      }